/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable camelcase */

export const pathPrefix = global.pathPrefix || ''
export const applicationName = global.applicationName || 'GoAlert'

export const GOALERT_VERSION = global.GOALERT_VERSION || 'dev'

export const isCypress = Boolean(global.Cypress)
